<div class="language-container">
  <span class="span-label">{{'edp.emarket.idioma' | translate}}</span>
  <div class="input-dropdown-container">
    @if (!showDropdown) {
      <div (click)="toggleDropdown()" class="input-dropdown">
        <span>{{languageSelected}}</span>
        <i class="icon-edponline-Bra-073"></i>
      </div>
    }
    @if (showDropdown) {
      <div class="dropdown-options">
        @for (language of dropdownLanguages; track language; let first = $first) {
          <div (click)="onSelect(language)" class="dropdown-option">
            {{language.label}}
            @if (first) {
              <i class="icon-edponline-Bra-073" style="transform: rotate(180deg);"></i>
              <div class="lang-divider"></div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>